import { render, staticRenderFns } from "./drawerProjectsTaskFlowStart.vue?vue&type=template&id=95b05d32&"
import script from "./drawerProjectsTaskFlowStart.vue?vue&type=script&lang=js&"
export * from "./drawerProjectsTaskFlowStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports